import { NgModule, /*Directive*/ } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DragDropModule } from 'primeng/dragdrop';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SliderModule } from 'primeng/slider';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { TabViewModule } from 'primeng/tabview';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { MegaMenuModule } from 'primeng/megamenu';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { SplitterModule } from 'primeng/splitter';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SelectButtonModule } from 'primeng/selectbutton';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { EditorModule } from 'primeng/editor';
import { ProgressBarModule } from 'primeng/progressbar';
import { StepsModule } from 'primeng/steps';
import { InputNumberModule } from 'primeng/inputnumber';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RippleModule } from 'primeng/ripple';

@NgModule({
    imports: [
        FileUploadModule,
        DragDropModule,
        SliderModule,
        ChartModule,
        InputTextModule,
        CheckboxModule,
        InputTextareaModule,
        ChipsModule,
        AutoCompleteModule,
        DropdownModule,
        MultiSelectModule,
        ListboxModule,
        TabViewModule,
        ColorPickerModule,
        TableModule,
        TreeModule,
        MegaMenuModule,
        VirtualScrollerModule,
        SplitterModule,
        InputSwitchModule,
        SelectButtonModule,
        KeyFilterModule,
        AccordionModule,
        TooltipModule,
        ToggleButtonModule,
        EditorModule,
        ProgressBarModule,
        StepsModule,
        InputNumberModule,
        CardModule,
        DialogModule,
        ButtonModule,
        MenuModule,
        OverlayPanelModule,
        RippleModule
        //Directive
    ],
    exports: [
        FileUploadModule,
        DragDropModule,
        ChartModule,
        SliderModule,
        InputTextModule,
        CheckboxModule,
        InputTextareaModule,
        ChipsModule,
        AutoCompleteModule,
        DropdownModule,
        MultiSelectModule,
        ListboxModule,
        TabViewModule,
        ColorPickerModule,
        TableModule,
        TreeModule,
        MegaMenuModule,
        VirtualScrollerModule,
        SplitterModule,
        InputSwitchModule,
        SelectButtonModule,
        KeyFilterModule,
        AccordionModule,
        TooltipModule,
        ToggleButtonModule,
        EditorModule,
        ProgressBarModule,
        StepsModule,
        InputNumberModule,
        CardModule,
        DialogModule,
        ButtonModule,
        MenuModule,
        OverlayPanelModule,
        RippleModule
        //Directive
    ]
})
export class PrimeNgModule { }
